export default __webpack_public_path__ + "static/media/logo-new-nobg-black.9a7bed74.png";